// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Le tue credenziali Firebase copiate dalla console
const firebaseConfig = {
    apiKey: "AIzaSyCNlqiY8ZDDImwON8m4je9_iKVO0DiNhBs",
    authDomain: "lanticopioldefeltre.firebaseapp.com",
    projectId: "lanticopioldefeltre",
    storageBucket: "lanticopioldefeltre.firebasestorage.app",
    messagingSenderId: "1033270494405",
    appId: "1:1033270494405:web:a0ed8b7e5e0c58bb01dcac",
    measurementId: "G-PW1YXBLH41"
  };

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
// const analytics = getAnalytics(app); // Opzionale

export { auth, db, storage };